import styles from './index.module.sass';
import {
  $rustmixBuyerPrices,
} from '../../store/calculator.store';
import { useStore } from 'effector-react';
import { useEffect, useRef, useState } from 'react';
import { TableDataRow } from './components/table-data-row';

export const CalculatorTable = ({
  fields,
  totalData,
}: {
  fields: { label: string; id: number; enabled: boolean; value: string }[];
  totalData: any;
}) => {
  const rustmixPrices = useStore($rustmixBuyerPrices);
  const [compOneSuggestionVisible, setCompOneSuggestionVisible] = useState<{
    visible: boolean;
    side: 'left' | 'right' | null;
  }>({ visible: false, side: null });
  const [compTwoSuggestionVisible, setCompTwoSuggestionVisible] = useState<{
    visible: boolean;
    side: 'left' | 'right' | null;
  }>({ visible: false, side: null });

  const tableRef: any = useRef(null);
  const comp1Ref: any = useRef(null);
  const comp2Ref: any = useRef(null);

  useEffect(() => {
    if (comp1Ref.current) {
      const observer = new IntersectionObserver((entries) => {
        if (entries && entries.length > 0) {
          setCompOneSuggestionVisible({
            visible: !entries[0].isIntersecting,
            side: null,
          });
        }
      });
      
      const timeoutId = setTimeout(() => {
        if (comp1Ref.current) {
          observer.observe(comp1Ref.current);
        }
      }, 100);
  
      return () => {
        clearTimeout(timeoutId);
        observer.disconnect();
      };
    }
  }, [totalData.resId]);

  useEffect(() => {
    if (comp2Ref.current) {
      const observer = new IntersectionObserver((entries) => {
        if (entries && entries.length > 0) {
          setCompTwoSuggestionVisible({
            visible: !entries[0].isIntersecting,
            side: null,
          });
        }
      });

      const timeoutId = setTimeout(() => {
        if (comp2Ref.current) {
          observer.observe(comp2Ref.current);
        }
      }, 100);
  
      return () => {
        clearTimeout(timeoutId);
        observer.disconnect();
      };
    }
  }, [totalData.resId]);

  useEffect(() => {
    const handleScroll = (e: any) => {
      if (tableRef.current && tableRef.current.contains(e.target)) {
        e.preventDefault();
      }
    };
    window.addEventListener('wheel', handleScroll, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleScroll);
    };
  }, []);

  const scrollToSmooth = (distance: number) => {
    if (tableRef.current) {
      const startScrollLeft = tableRef.current.scrollLeft;
      const step = 10;

      const animateScroll = () => {
        const targetScrollLeft = startScrollLeft + distance;
        const scrollStep = Math.max(1, Math.abs(targetScrollLeft - tableRef.current.scrollLeft) / 10);

        if (distance > 0) {
          if (tableRef.current.scrollLeft < targetScrollLeft && (tableRef.current.scrollWidth - tableRef.current.clientWidth) > tableRef.current.scrollLeft) {
            tableRef.current.scrollLeft += scrollStep;
            requestAnimationFrame(animateScroll);
          }
        } else {
          if (tableRef.current.scrollLeft > targetScrollLeft && tableRef.current.scrollLeft > 1) {
            tableRef.current.scrollLeft -= scrollStep;
            requestAnimationFrame(animateScroll);
          }
        }
      };

      animateScroll();
      return;
    }
  };

  const handleWheelScroll = (e: any) => {
    // e.preventDefault();
    const delta = Math.max(-1, Math.min(1, (e.deltaY || -e.wheelDelta || e.detail)));

    if (tableRef.current) {
      tableRef.current.scrollLeft -= delta * 50;
    }
  };

  return (
    <div className={styles.topRoot}>
      {compOneSuggestionVisible.visible && (
        <div
          className={styles.compOneSuggestion}
          onClick={() => {
            if (comp1Ref.current) {
              comp1Ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }}
        >
          показать комп. 1{/* <span className={styles.shadowHelper}></span> */}
        </div>
      )}

      {compTwoSuggestionVisible.visible && (
        <div
          className={styles.compTwoSuggestion}
          onClick={() => {
            if (comp2Ref.current) {
              comp2Ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }}
        >
          показать комп. 2{/* <span className={styles.shadowHelper}></span> */}
        </div>
      )}

      <span className={styles.prevArrow} onClick={() => scrollToSmooth(-400)}>
        <span className={styles.filler}></span>
      </span>
      <span className={styles.nextArrow} onClick={() => scrollToSmooth(400)}>
        <span className={styles.filler}></span>
      </span>
      <div className={styles.root} ref={tableRef} onWheel={(e) => handleWheelScroll(e)}>
        <div className={styles.tableBody}>
          <ul className={styles.tableCols}>
            <li className={styles.tableCol}>
              {!totalData.bagAId && (
                <div className={styles.topCompWd} style={{ borderRadius: '0' }}>
                  комп 1
                </div>
              )}
            </li>
            <li className={styles.tableCol}></li>
            <li className={styles.tableCol}></li>
            {fields.map((item, i) => {
              if (item.enabled)
                return (
                  <li className={styles.tableCol} key={i}>
                    {item.label}
                  </li>
                );
            })}
            <li className={styles.tableCol}></li>
            <li className={styles.tableCol}></li>
            <li className={styles.tableCol}>
              {!totalData.bagBId && (
                <div className={styles.bottomCompWd} style={{ borderRadius: '0' }}>
                  комп 2
                </div>
              )}
            </li>
          </ul>
          {Array.isArray(rustmixPrices) && rustmixPrices.length > 0 ? (
            rustmixPrices.map((item, i) => (
              <TableDataRow
                key={i}
                active={totalData.resId === item.id}
                fields={fields}
                data={item}
                topComp={item.id === totalData.bagAId}
                topCompRef={comp1Ref}
                bottomComp={item.id === totalData.bagBId}
                bottomCompRef={comp2Ref}
              />
            ))
          ) : (
            <div className={styles.placeholder}>
              Покупатели не выбраны, или отсутствуют предложения
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
